export type AdDataType = {
  id: number;
  companyName: string;
  status: string;
  description: string;
  postedOn: string;
  address: string;
  startDate: string;
  EndDate: string;
  url: string;
  bannerImage: string;
  verticalImage: string;
  SquareImage: string;
  Budget: string;
  AdCategory: string;
  AdDuration: string;
  projectLogo: string;
};

export const AdData: Array<AdDataType> = [
  {
    id: 1,
    companyName: "COINBASE GLOBAL, INC",
    status: "approved",
    address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    description:
      "Coinbase Global, Inc. operates as a secure hosted bitcoin wallet to purchase and use bitcoin. It provides merchant tools that enable companies to accept payments in bitcoin by incorporating a single button. The company was founded by Brian Armstrong in 2012 and is headquartered in San Francisco, CA.",
    postedOn: "18/Nov/2022",
    startDate: "21/Nov/2022",
    EndDate: "25/Nov/2022",
    url: "https://www.coinbase.com/",
    bannerImage: "",
    verticalImage: "",
    SquareImage: "",
    Budget: "1 Eth",
    AdCategory: "Web3",
    AdDuration: "4 days",
    projectLogo:
      "https://logosarchive.com/wp-content/uploads/2021/12/Coinbase-logo-square-1.svg",
  },
  {
    id: 2,
    companyName: "Theta",
    status: "approved",
    address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    description:
      "The Theta blockchain protocol is a decentralized ledger that aims to serve video streaming industries. Based on the Proof-of-Stake consensus mechanism, it encourages and incentivizes content creators for sharing their bandwidth and content on video platforms.",
    postedOn: "18/Nov/2022",
    startDate: "19/Nov/2022",
    EndDate: "24/Nov/2022",
    url: "https://www.thetatoken.org/",
    bannerImage: "",
    verticalImage: "",
    SquareImage: "",
    Budget: "0.5 Eth",
    AdCategory: "Web3",
    AdDuration: "3 days",
    projectLogo:
      "https://upload.wikimedia.org/wikipedia/commons/2/26/Theta_Token_logo.png",
  },
  {
    id: 3,
    companyName: "Polkadot",
    status: "approved",
    address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    description:
      "The Polkadot protocol is a cross-chain interoperable platform that allows seamless transfer of data between two unrelated blockchain networks like Bitcoin and Ethereum. DOT is the native token of the platform, and can be used for buying, selling, and staking, and also allows token holders to take part in the governance protocol of the Polkadot platform.",
    postedOn: "20/Nov/2022",
    startDate: "23/Dec/2022",
    EndDate: "30/Dec/2022",
    url: "https://polkadot.network/",
    bannerImage: "",
    verticalImage: "",
    SquareImage: "",
    Budget: "1.2 Eth",
    AdCategory: "Web3",
    AdDuration: "8 days",
    projectLogo:
      "https://www.pngall.com/wp-content/uploads/10/Polkadot-Crypto-Logo-PNG-File.png",
  },
  {
    id: 4,
    companyName: "Brave browser",
    status: "declined",
    address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    description:
      "The Brave browser takes one step closer to Web3 by integrating to InterPlanetery File System (IFPS), a P2P (peer-to-peer) file-sharing network. Brave has always focused on privacy, and now its recent integration with IFPS will further ensure the efficacy of a fully decentralized web. Currently, the browser is available for Windows, Mac, and Linux.",
    postedOn: "22/Nov/2022",
    startDate: "21/Dec/2022",
    EndDate: "25/Dec/2022",
    url: "https://brave.com/",
    bannerImage: "",
    verticalImage: "",
    SquareImage: "",
    Budget: "0.2 Eth",
    AdCategory: "Web3",
    AdDuration: "5 days",
    projectLogo:
      "https://www.kindpng.com/picc/m/210-2101184_the-logo-for-the-brave-browser-brave-browser.png",
  },
  {
    id: 5,
    companyName: "Basic Attention Token (BAT)",
    status: "pending",
    address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    description:
      "BAT is the native token of the Brave Ads ecosystem that tokenizes user attention. Based on Web3 solutions, BAT connects publishers and advertisers. It eliminates mediators or intermediaries, and publishers can send BATs directly to the advertiser’s wallet via the Brave browser.",
    postedOn: "21/Nov/2022",
    startDate: "27/Dec/2022",
    EndDate: "06/Jan/2023",
    url: "https://basicattentiontoken.org",
    bannerImage: "",
    verticalImage: "",
    SquareImage: "",
    Budget: "2 Eth",
    AdCategory: "Web3",
    AdDuration: "10 days",
    projectLogo:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/Brave_Basic_Attention_Token_%28BAT%29_Logo.svg/1200px-Brave_Basic_Attention_Token_%28BAT%29_Logo.svg.png",
  },
];

export type VoteType = {
  id: number;
  address: string;
  numberOfVotes: number;
};

export type DappDataType = {
  id: number;
  address: string;
  dappName: string;
  logo: string;
  description: string;
  AppCategory: string;
  AdDeals: number;
  RegisterAt: string;
  DappContractAddress: string;
  url: string;
  following: number;
  voters: Array<VoteType>;
};

export const dappData: Array<DappDataType> = [
  {
    id: 1,
    address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    logo:
      "https://user-images.githubusercontent.com/35243/140804979-0ef11e0d-d527-43c1-93cb-0f48d1aec542.png",
    dappName: "Open Sea",
    description:
      "Building an open digital economy At OpenSea, we're excited about a brand new type of digital good called a non-fungible token, or NFT. NFTs have exciting new properties: they’re unique, provably scarce, tradeable, and usable across multiple applications. Just like physical goods, you can do whatever you want with them! You could throw them in the trash, gift them to a friend across the world, or go sell them on an open marketplace. But unlike physical goods, they're armed with all the programmability of digital goods. A core part of our vision is that open protocols like Ethereum and interoperable standards like ERC-721 and ERC-1155 will enable vibrant new economies. We're building tools that allow consumers to trade their items freely, creators to launch new digital works, and developers to build rich, integrated marketplaces for their digital items. We’re proud to be the first and largest marketplace for NFTs.",
    AppCategory: "Web3/Blockchain",
    AdDeals: 5,
    RegisterAt: "18/Nov/2022",
    DappContractAddress: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    url: "https://opensea.io/",
    following: 100,
    voters: [
      {
        id: 1,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 3,
      },
      {
        id: 2,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 4,
      },
      {
        id: 3,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 0,
      },
      {
        id: 4,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 1,
      },
      {
        id: 5,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 4,
      },
    ],
  },
  {
    id: 2,
    address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    logo:
      "https://seeklogo.com/images/P/pancakeswap-cake-logo-5ED529C1F6-seeklogo.com.png?v=637922867320000000",
    dappName: "PancakeSwap",
    description:
      "PancakeSwap is a decentralized exchange (DEX). This decentralized exchange, built on Binance Smart Chain, allows users to swap between two BEP20 tokens.",
    AppCategory: "Web3/Blockchain",
    AdDeals: 7,
    RegisterAt: "22/Nov/2022",
    DappContractAddress: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    url: "https://pancakeswap.finance/",
    following: 200,
    voters: [
      {
        id: 1,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 10,
      },
      {
        id: 2,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 4,
      },
      {
        id: 3,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 0,
      },
      {
        id: 4,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 1,
      },
      {
        id: 5,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 4,
      },
      {
        id: 6,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 0,
      },
      {
        id: 7,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 1,
      },
    ],
  },
  {
    id: 3,
    address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    logo:
      "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcThVssprvK-dBdJoqlMxlIWjjs4-vzGU52Hsv0k4pk&s",
    dappName: "Compound",
    description:
      "Compound is a DApp that allows users to borrow, lend and earn interest in certain cryptocurrencies.",
    AppCategory: "Web3/Blockchain",
    AdDeals: 12,
    RegisterAt: "15/Nov/2022",
    DappContractAddress: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    url: "https://compound.finance/",
    following: 300,
    voters: [
      {
        id: 1,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 8,
      },
      {
        id: 2,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 2,
      },
      {
        id: 3,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 1,
      },
    ],
  },
  {
    id: 4,
    address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    logo:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/e/e7/Uniswap_Logo.svg/2051px-Uniswap_Logo.svg.png",
    dappName: "Uniswap V2",
    description:
      "Uniswap V2 is the second iteration of the decentralized protocol Uniswap. With the introduction of Uniswap V2, the users no longer needed to add ETH as one of the crypto assets.",
    AppCategory: "Web3/Blockchain",
    AdDeals: 10,
    RegisterAt: "12/Nov/2022",
    DappContractAddress: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    url: "https://uniswap.org/",
    following: 250,
    voters: [
      {
        id: 1,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 10,
      },
      {
        id: 2,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 4,
      },
      {
        id: 3,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 0,
      },
      {
        id: 4,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 1,
      },
    ],
  },
  {
    id: 5,
    address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    logo:
      "https://dashboard-assets.dappradar.com/document/5314/alienworlds-dapp-games-wax-logo-166x166_15c50909678e70f765b11dda14fc5e1e.png",
    dappName: "Alien Worlds",
    description:
      "Alien Worlds consists of an NFT Metaverse that uses digital gaming assets to engage and compete in various gaming modes.",
    AppCategory: "Web3/Blockchain",
    AdDeals: 10,
    RegisterAt: "10/Nov/2022",
    DappContractAddress: "0xD7a05f16121B01aa80747ef950190dD54131971b",
    url: "https://alienworlds.io/",
    following: 300,
    voters: [
      {
        id: 1,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 10,
      },
      {
        id: 2,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 8,
      },
      {
        id: 3,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 2,
      },
      {
        id: 4,
        address: "0xD7a05f16121B01aa80747ef950190dD54131971b",
        numberOfVotes: 1,
      },
    ],
  },
];
